module.exports = __webpack_public_path__ + "static/Twilio2-065e0e04dd595e2b5bad45aa561d5dc1.png";